<template>
  <div class="content-panel" v-if="getCurrentUser">
    <div class="panel-title">
      <h3>Account Navigation</h3>
    </div>
    <div class="panel-body no-padding">
      <nav class="sub-nav">
        <ul>
          <li 
            v-for="(link, index) in links"
            :key="index"
            :class="[{ active: currentLink === link.label }]"
          >
            <router-link :to="link.route" :title="link.label" v-if="link.visible.includes(getCurrentUser.claims.role)">
              <i :class="link.icon"></i> {{ link.label }}
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>

import {auth} from "@/firebaseConfig";
import {mapGetters} from 'vuex';

export default {
  name: 'AccountNavigation',

  data () {
    let self = this;
    return {
      currentLink: "General",
      currentUser: auth.currentUser,
      links: [ 
        {
          label: 'General',
          route: `/${self.$i18n.locale}/admin/account/`,
          icon: 'fal fa-info-circle',
          visible: ['su','admin','agent']
        }
      ]
    }
  },

  computed: {
    ...mapGetters([
      'getCurrentUser'
    ])
  }
}
</script>